import { z } from 'zod';
import { DeviceGenre } from '@/features/device/genre/type';
import { dataGridSearchFields } from '@/features/dynamic-table';
import { CategoryKey, TabKey } from './-constants';
import type { SortableFieldKey } from './-query/type';
const DEVICE_INVENTORY_SORT_COLUMNS = ['DeviceName', 'DeviceSerialNumber', 'AssetTag', 'DeviceTag', 'ModelName'] as const satisfies readonly SortableFieldKey[];
export function isDeviceInventorySortColumn(value: string | undefined): value is SortableFieldKey {
  return value !== undefined && (DEVICE_INVENTORY_SORT_COLUMNS as readonly string[]).includes(value);
}
export const SearchSchema = z.object({
  ...dataGridSearchFields,
  sortColumn: z.enum(DEVICE_INVENTORY_SORT_COLUMNS).optional(),
  menu: z.nativeEnum(TabKey).default(TabKey.ALL),
  category: z.nativeEnum(CategoryKey).default(CategoryKey.ALL),
  genres: z.array(z.nativeEnum(DeviceGenre)).optional(),
  freeText: z.string().optional(),
  placementPlaceIds: z.array(z.string()).optional(),
  warehousingPlaceIds: z.array(z.string()).optional()
});
export type SearchSchema = z.infer<typeof SearchSchema>;